import { Regions, RegionsCode } from '../constants/region';
import { TtsLocale } from '../models/Base';

export const getLocalCurrencyByRegion = (id: RegionsCode | undefined) => {
  switch (id) {
    default:
      return 'USD';
    case RegionsCode.HK:
      return 'HKD';
    case RegionsCode.CN:
      return 'CNY';
    case RegionsCode.TW:
      return 'TWD';
    case RegionsCode.MO:
      return 'HKD';
  }
};

export const getWritingLocaleByRegion = (id: RegionsCode) => {
  switch (id) {
    case RegionsCode.HK:
      return TtsLocale.HK;
    case RegionsCode.CN:
      return TtsLocale.CN;
    case RegionsCode.TW:
      return TtsLocale.TW;
    case RegionsCode.JP:
      return TtsLocale.JP;
    case RegionsCode.US:
      return TtsLocale.US;
    default:
      return TtsLocale.HK;
  }
};

export const isValidRegionCode = (id: string) => {
  return Object.keys(RegionsCode).includes(id);
};

export function getRegionInfo(regionCode: RegionsCode | null | undefined) {
  if (!regionCode) {
    return {
      country: 'Unknown',
      image: null,
    };
  }

  const region = Regions.find((r) => r.id === regionCode);

  if (region) {
    return {
      country: region.country || 'Unknown',
      image: region.image,
    };
  } else {
    return {
      country: 'Unknown',
      image: null,
    };
  }
}

export function getRegionPhoneCode(regionCode: RegionsCode | null | undefined) {
  if (!regionCode) {
    return '';
  }
  const region = Regions.find((r) => r.id === regionCode);
  if (region) {
    return region.countryCodes;
  } else {
    return '';
  }
}

export function getRegionFromPhoneCode(
  phoneCode: string,
): RegionsCode | undefined {
  if (!phoneCode) {
    return undefined;
  }
  if (phoneCode.startsWith('+')) {
    // Remove the "+" sign from the beginning of the phoneCode
    phoneCode = phoneCode.slice(1);
  }
  const region = Regions.find((r) => r.countryCodes?.includes(phoneCode));
  if (region && region.id !== 'worldwide') {
    return region.id;
  }
  return undefined;
}
